/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Weird_Gull_PoutInputs */

const fr_salty_weird_gull_pout = /** @type {(inputs: Salty_Weird_Gull_PoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégories de programmes`)
};

/**

* @param {Salty_Weird_Gull_PoutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_weird_gull_pout = /** @type {((inputs?: Salty_Weird_Gull_PoutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Weird_Gull_PoutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_weird_gull_pout(inputs)
});